import {Button, Column, Text} from 'native-base';
import {CreateTeamProvider, useProvideCreateTeam} from '@ui/provider/CreateTeamProvider';
import React, {useState} from 'react';
import BottomsheetProps from '@ui/components/sheet/BottomsheetProps';
import CarouselBottomsheet from '@ui/components/carousel/CarouselBottomsheet';
import ParticipantAvatar from '@ui/components/participant/ParticipantAvatar';
import {Platform} from 'react-native';
import {PresenceLoadingScreen} from '@ui/components/LoadingScreen';
import {TeamCreate} from './TeamCreateScreen';
import TeamInvitePlayers from '../detail/TeamInvitePlayers';
import {useTeam} from '../detail/team-hooks';
import {useTranslation} from 'react-i18next';

interface TeamCreatedScreenProps {
    onFinish: () => void;
    teamId: string;
}

const TeamCreatedScreen = (props: TeamCreatedScreenProps) => {
    const {onFinish, teamId} = props;
    const {t} = useTranslation();
    const [team, isTeamLoading] = useTeam(teamId!);

    return (
        <PresenceLoadingScreen isLoading={isTeamLoading} showContent={team !== undefined}>
            <Column safeAreaBottom space='2' alignItems="center" flex={1} h='full' p='4'>
                <ParticipantAvatar participant={team} _avatar={{size: 'xl'}} _text={{color: 'black', variant: 'boldH5', pt: 4}}/>

                <Text flex={1} color='blacks.900' textAlign="center" variant='bodyLg'>{t('team.create.subtitle')}</Text>

                <TeamInvitePlayers team={team!} />

                <Button onPress={onFinish} w='full'>{t('competition.action.join')}</Button>
            </Column>
        </PresenceLoadingScreen>
    );
};


interface Props extends Omit<BottomsheetProps, 'children'> {
    onTeamCreated: (teamId: string) => void;
}

const TeamCreateModal = (props: Props) => {
    const {onTeamCreated, isOpen, onClose} = props;
    const {t} = useTranslation();
    const [page, setPage] = useState<number>(0);
    const [teamId, setTeamId] = useState<string>('');
    const createTeamProvider = useProvideCreateTeam();

    const onTeamCreatedHandler = (teamId: string) => {
        setTeamId(teamId);
        setPage(1);
    };

    const onFinishedAddingPlayers = () => {
        onTeamCreated(teamId);
        setPage(0);
        onClose();
    };

    const snapPoints = Platform.OS === 'web' ? ['70%', '70%'] : ['70%', '70%'];

    return (
        <CarouselBottomsheet
            isOpen={isOpen}
            onClose={onClose}
            titles={[t('team.create.title'), '']}
            page={page}
            snapPoints={snapPoints}
        >
            <CreateTeamProvider key={0} value={createTeamProvider}>
                <TeamCreate onTeamCreated={onTeamCreatedHandler}/>
            </CreateTeamProvider>

            <TeamCreatedScreen key={1} onFinish={onFinishedAddingPlayers} teamId={teamId}/>
        </CarouselBottomsheet>
    );
};

export default TeamCreateModal;

